<template>
  <div class="page">
    <transition
      appear
      name="opbouwanimatie"
      mode="out-in"
      v-bind:css="false"
      v-on:enter="enter"
    >
      <main>
        <div class="ovalyellow stappen"></div>
        <div class="ovalgreen stappen"></div>
        <div class="line_header"></div>
        <div class="rightdown"></div>
        <div class="leftdown"></div>
        <levensweg-header icon="?"></levensweg-header>
        <header>
          <pager class="pager" start="5" end="05" />
          <h2 class="titleslide stappen">Berekening</h2>
          <p class="bodyslide stappen">
            je wil dus op {{ age }} beginnen aan kinderen en je wilt graag
            {{ kinderen }} kinderen.
          </p>
        </header>

        <levensweg-button
          class="backButton"
          label="Terug"
          color="orange left"
          link="/stap4b"
        />
      </main>
    </transition>
  </div>
</template>

<script>
import Header from "./../components/Header";
import Levenswegbutton from "./../components/Levenswegbutton";
import Pager from "./../components/Pager";

import { TimelineMax, Elastic, Sine, Expo } from "gsap";

let tl;

export default {
  components: {
    "levensweg-header": Header,
    "levensweg-button": Levenswegbutton,
    pager: Pager,
  },
  computed: {
    age() {
      let compAge =
        18 +
        this.$store.state.verderstuderen +
        this.$store.state.activiteitentijd;
      return compAge;
    },
    kinderen() {
      return this.$store.state.aantalkindereren;
    },
  },
  beforeRouteLeave(to, from, next) {
    let outroline = new TimelineMax({ paused: true });
    outroline
      .to(".titleslide", 1, { opacity: 0, ease: Sine.easeIn })
      .to(".titleslide", 0.5, { x: 50, ease: Sine.easeOut }, "-=0.8")
      .to(".bodyslide", 1, { x: 50, opacity: 0, ease: Expo.easeOut }, "-=0.6")
      .fromTo(
        ".nobutton",
        0.3,
        { scale: 1 },
        { scale: 0, ease: Elastic.easeOut.config(1, 1.5) },
        "-=1.0"
      )
      .fromTo(
        ".yesbutton",
        0.3,
        { scale: 1 },
        { scale: 0, ease: Elastic.easeOut.config(1, 1.5) },
        "-=0.7"
      );

    outroline.eventCallback("onComplete", () => {
      //console.log("outro ready");
      next();
    });
    outroline.timeScale(1.3);
    outroline.play();
  },

  methods: {
    enter: function(el, done) {
      tl = new TimelineMax({ paused: true });
      //const ornaHeight = document.querySelector(".line_header").clientHeight;
      //const ornaWidth = document.querySelector(".line_header").clientWidth;

      tl.add("enter");
      //tl.from(".pager",1,{opacity:0,ease:Sine.easeIn})
      //.from(".pager",0.5,{x:50,ease:Sine.easeOut},"-=0.8")
      tl.from(".titleslide", 1, { opacity: 0, ease: Sine.easeIn })
        .from(".titleslide", 0.5, { x: 50, ease: Sine.easeOut }, "-=0.8")
        //.fromTo(".line_header",1.5,{clip:`rect(0px, ${ornaWidth}px, 0px, 0px)`},{clip:`rect(0px, ${ornaWidth}px, ${ornaHeight}px, 0px)`, ease:Expo.easeOut},"-=0.5")
        .from(
          ".bodyslide",
          0.8,
          { x: 50, opacity: 0, ease: Expo.easeOut },
          "-=0.6"
        )
        .fromTo(
          ".yesbutton",
          0.3,
          { scale: 0 },
          { scale: 1, ease: Elastic.easeOut.config(1, 1.5) }
        )
        .fromTo(
          ".nobutton",
          0.3,
          { scale: 0 },
          { scale: 1, ease: Elastic.easeOut.config(1, 1.5) }
        );
      //.fromTo(".ovalyellow",1.5,{scale:0, transformOrigin:"0% 0%"},{scale:1, ease:Elastic.easeOut.config(1,0.8)},"-=0.7")
      //.fromTo(".ovalgreen",1.5,{scale:0, transformOrigin:"100% 100%"},{scale:1, ease:Elastic.easeOut.config(1,0.8)},"-=0.8")
      tl.timeScale(1.3);
      //tl.delay(1.6);
      tl.eventCallback("onComplete", () => {
        done();
      });
      tl.play();
    },
  },
};
</script>

<style>
.line_header {
  background-image: url("../assets/img/line_small.svg");
  background-repeat: no-repeat;
  background-size: contain;
  width: 128px;
  height: 89.8px;
  left: 20px;
  position: absolute;
  z-index: -1;
}

.rightdown {
  background-image: url("../assets/img/right.svg");
  background-repeat: no-repeat;
  background-size: contain;
  width: 114.2px;
  height: 140.5px;
  position: absolute;
  z-index: -1;
  bottom: 0px;
  right: 0px;
}

.leftdown {
  background-image: url("../assets/img/left.svg");
  background-repeat: no-repeat;
  background-size: contain;
  width: 99.4px;
  height: 166px;
  position: absolute;
  z-index: -1;
  bottom: 0px;
  left: 0px;
}

.ovalyellow.stappen {
  background-image: url("../assets/img/homehalfovalyellow.svg");
  background-repeat: no-repeat;
  background-size: contain;
  width: 106px;
  height: 273px;
  position: absolute;
  z-index: -2;
  filter: brightness(0) saturate(100%) invert(100%) sepia(11%) saturate(0%)
    hue-rotate(50deg) brightness(105%) contrast(101%);
}

.ovalgreen.stappen {
  background-image: url("../assets/img/homehalfovalgreen.svg");
  background-repeat: no-repeat;
  background-size: contain;
  width: 97px;
  height: 327px;
  position: absolute;
  bottom: 25px;
  right: 0px;
  z-index: -1;
  filter: brightness(0) saturate(100%) invert(100%) sepia(11%) saturate(0%)
    hue-rotate(50deg) brightness(105%) contrast(101%);
}
.backButton {
  /*margin: 2.2rem 1.8rem 3rem 1.8rem;*/
  position: absolute;
  bottom: 30px;
  left: 18px;
}
.nextButton {
  position: absolute;
  bottom: 30px;
  right: 18px;
}

.stappen {
  margin-top: 0;
}

.pager {
  margin-top: 10.7rem;
  margin-left: 1.7rem;
}

.bodyslide {
  margin-top: 1.5rem;
}
.blobcontainer {
  margin-top: 5rem;
  display: flex;
  justify-content: center;
}
.nobutton {
  margin-top: -2.5rem;
  margin-left: -0.5rem;
}

/* tablet */
@media only screen and (min-width: 768px) {
  .page {
    position: relative;
    height: 550px;
  }
}

@media only screen and (min-width: 992px) {
  .ovalyellow.stappen {
    background-image: url("../assets/img/oval_left_big_step.svg");
    background-repeat: no-repeat;
    background-size: contain;
    width: 335px;
    height: 705px;
    position: absolute;
    z-index: -2;
    margin-top: -5px;
  }

  .ovalgreen.stappen {
    background-image: url("../assets/img/oval_right_big_step.svg");
    background-repeat: no-repeat;
    background-size: contain;
    width: 366px;
    height: 518px;
    top: 0;
  }

  .page {
    position: relative;
    height: 700px;
  }
  .titleslide.stappen {
    margin-left: 25rem;
  }
  .pager {
    margin-top: 9.3rem;
    margin-left: 20.1rem;
  }
  .bodyslide.stappen {
    margin-left: 25rem;
  }
}
@media only screen and (min-width: 1200px) {
  .ovalyellow.stappen {
    width: 335px;
    height: 705px;
    margin-top: 6.3rem;
  }

  .line_header {
    width: 128px;
    height: 139.8px;
    left: unset;
  }

  .page {
    height: 768px;
    max-width: 1200px;
    margin: 0 auto;
    padding-left: 83px;
    padding-right: 84px;
    overflow: hidden;
  }

  .backButton {
    left: 88px;
  }

  .leftdown {
    width: 131px;
    height: 218px;
  }

  .rightdown {
    width: 149px;
    height: 179px;
  }
}
</style>
